

function FooterMain(){

    return(
        <>
            <p>Footer</p>
        </>
    );

}

export default FooterMain;